<template>
  <div class="select">
    <label class="select__label" v-if="label">
      {{ label }}
    </label>
    <v-select
      class="v-select"
      :class="{ 'v-select--label': label }"
      :options="options"
      :clearable="false"
      :searchable="false"
      :appendToBody="true"
      v-model="inputVal"
    />
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';

export default {
  name: 'Select',
  components: {
    vSelect
  },
  props: {
    options: Array,
    value: Object,
    label: String
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss">
/** Intentionally not scoped, as the dropdown element will be appended to the end of the body */
.select {
  position: relative;

  &__label {
    top: 9px;
    left: 16px;
    position: absolute;
    font-size: 0.8rem;
    font-weight: bold;
    display: block;
    color: $grey-1;
    z-index: 1;
    pointer-events: none;
  }
}

.vs__dropdown-option {
  padding-left: 25px;
  margin-bottom: 5px;
  transition: 0.1s;
  color: white;

  &--highlight,
  &--selected {
    border-radius: 8px;
    position: relative;
  }

  &--selected {
    transition: 0.2s;
    background-color: $grey-5;

    &:before {
      content: '';
      position: absolute;
      left: 7px;
      top: 11px;
      width: 12px;
      height: 12px;
      background-image: url('~@/assets/settings-icons/dropdown-tick.svg');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  &--highlight {
    background-color: $grey-4;
  }
}

.vs__dropdown-menu {
  background-color: $grey-7;
  border-radius: 15px;
  padding: 10px;
}

.v-select {
  width: 100%;
  background-color: $grey-5;
  padding: 10px 15px 10px 6px;
  border-radius: 15px;
  transition: background-color 0.1s;
  color: white;
  height: 61px;
  font-size: 1rem;
  font-weight: bold;
}

.vs__open-indicator {
  fill: $grey-1;
}

.vs__selected {
  color: white;
  opacity: 1 !important;
  margin-top: 14px;
}

.vs__dropdown-toggle {
  border: none;
  width: 100%;
  height: 100%;
  background: none !important;
}
</style>
